import * as z from 'zod';

import { AddAccountCommentEvent } from './AddAccountCommentEvent';
import { AddAdditionalBorrowerEvent } from './AddAdditionalBorrowerEvent';
import { AddAppraisalEvent } from './AddAppraisalEvent';
import { AddAppraisalOrderEvent } from './AddAppraisalOrderEvent';
import { AddAuditLogItemEvent } from './AddAuditLogItemEvent';
import { AddInspectionEvent } from './AddInspectionEvent';
import { AddInspectionOrderEvent } from './AddInspectionOrderEvent';
import { AddLoanNoteEvent } from './AddLoanNoteEvent';
import { CancelFeeEvent } from './CancelFeeEvent';
import { ChangePrimaryBorrowerEvent } from './ChangePrimaryBorrowerEvent';
import { ConstructionToPermanentEvent } from './ConstructionToPermanentEvent';
import { CreateAdvancePaymentEvent } from './CreateAdvancePaymentEvent';
import { CreateBalanceReallocationEvent } from './CreateBalanceReallocationEvent';
import { CreateAdvanceEvent, CreateFeeEvent } from './CreateChargeEvent';
import { CreateClawBackTransferEvent } from './CreateClawBackTransferEvent';
import { CreateDepositEvent } from './CreateDepositEvent';
import { CreateDisbursementEvent } from './CreateDisbursementEvent';
import { CreateDrawEvent } from './CreateDrawEvent';
import { CreateEscrowSettingEvent } from './CreateEscrowSettingEvent';
import { CreateFeePaymentEvent } from './CreateFeePaymentEvent';
import { CreateForwardPaymentDisbursementEvent } from './CreateForwardPaymentDisbursementEvent';
import { CreateLoanExtensionAgreementEvent } from './CreateLoanExtensionAgreementEvent';
import { CreateLoanExtensionFeesDocumentEvent } from './CreateLoanExtensionFeesDocumentEvent';
import { CreateMultipleFeesPaymentEvent } from './CreateMultipleFeesPaymentEvent';
import { CreatePaymentAfterPayoffDisbursementEvent } from './CreatePaymentAfterPayoffDisbursementEvent';
import { CreatePaymentEvent } from './CreatePaymentEvent';
import { CreatePayoffEvent } from './CreatePayoffEvent';
import { CreatePrincipalModificationEvent } from './CreatePrincipalModificationEvent';
import { CreatePrincipalPrepaymentEvent } from './CreatePrincipalPrepaymentEvent';
import { CreatePropertyAddressEvent } from './CreatePropertyAddressEvent';
import { CreateRequestedPayoffEvent } from './CreateRequestedPayoffEvent';
import { CreateTransferEvent } from './CreateTransferEvent';
import { CreateVerificationOfMortgageEvent } from './CreateVerificationOfMortgageEvent';
import { CreationEvent } from './CreationEvent';
import { DeferDelinquentInterestEvent } from './DeferDelinquentInterestEvent';
import { DeleteDocumentEvent } from './DeleteDocumentEvent';
import { DeletePropertyAddressEvent } from './DeletePropertyAddressEvent';
import { DeleteReportableEventEvent } from './DeleteReportableEventEvent';
import { EditBorrowerEvent } from './EditBorrowerEvent';
import { EditEscrowFieldsEvent } from './EditEscrowFieldsEvent';
import { EditManualStatementEvent } from './EditManualStatementEvent';
import { FlagAccountEvent } from './FlagAccountEvent';
import { ForceUpdateEvent } from './ForceUpdateEvent';
import { GenerateGoodbyeLetterPdfEvent } from './GenerateGoodbyeLetterPdfEvent';
import { GenerateManualStatementEvent } from './GenerateManualStatementEvent';
import { GenerateNextStatementEvent } from './GenerateNextStatementEvent';
import { GracePastDueAutomationEvent } from './GracePastDueAutomationEvent';
import { LogCallEvent } from './LogCallEvent';
import { MailMonthlyStatementTaskEvent } from './MailMonthlyStatementTaskEvent';
import { ModifyMaturityDateEvent } from './ModifyMaturityDateEvent';
import { ModifyPropertyAddressEvent } from './ModifyPropertyAddressEvent';
import { MoveToTransferEvent } from './MoveToTransferEvent';
import { NextAmortizationMonthEvent } from './NextAmortizationMonthEvent';
import { PrincipalLateAutomationEvent } from './PrincipalLateAutomationEvent';
import { ReallocatePaymentsEvent } from './ReallocatePaymentsEvent';
import { RecordLiquidationEvent } from './RecordLiquidationEvent';
import { RecordPayoffEvent } from './RecordPayoffEvent';
import { RecordReoEvent } from './RecordReoEvent';
import { RecordWriteoffEvent } from './RecordWriteoffEvent';
import { RegenerateStatementEvent } from './RegenerateStatementEvent';
import { RegenerateStatementPdfEvent } from './RegenerateStatementPdfEvent';
import { RegenerateTransferDocumentsEvent } from './RegenerateTransferDocumentsEvent';
import { RemoveAdditionalBorrowerEvent } from './RemoveAdditionalBorrowerEvent';
import { RepayMarkAsCancelledEvent } from './RepayMarkAsCancelledEvent';
import { RepayMarkAsFailedEvent } from './RepayMarkAsFailedEvent';
import { RepayMarkAsProcessedEvent } from './RepayMarkAsProcessedEvent';
import { ReverseDisbursementEvent } from './ReverseDisbursementEvent';
import { ReverseDrawEvent } from './ReverseDrawEvent';
import { ReversePaymentEvent } from './ReversePaymentEvent';
import { ReversePayoffEvent } from './ReversePayoffEvent';
import { ReversePrincipalModificationEvent } from './ReversePrincipalModificationEvent';
import { SaveDocumentPdfEvent } from './SaveDocumentPdfEvent';
import { SaveStatementPdfEvent } from './SaveStatementPdfEvent';
import { SendEmailEvent } from './SendEmailEvent';
import { SendEscrowCompanyEmailsEvent } from './SendEscrowCompanyEmailsEvent';
import { SendExternalEmailEvent } from './SendExternalEmailEvent';
import { SendFinalPaymentEmailEvent } from './SendFinalPaymentEmailEvent';
import { SendGoodbyeEmailEvent } from './SendGoodbyeEmailEvent';
import { SendGracePastDueEmailEvent } from './SendGracePastDueEmailEvent';
import { SendLatePaymentEmailEvent } from './SendLatePaymentEmailEvent';
import { SendLenderEmailEvent } from './SendLenderEmailEvent';
import { SendMortgageeLetterEvent } from './SendMortgageeLetterEvent';
import { SendPaymentReminderEmailEvent } from './SendPaymentReminderEmailEvent';
import { SendWelcomeEmailEvent } from './SendWelcomeEmailEvent';
import { SetLoanStatusEvent } from './SetLoanStatusEvent';
import { SetLoanStatusForeclosureEvent } from './SetLoanStatusForeclosureEvent';
import { TransferAccountEvent } from './TransferAccountEvent';
import { UpdateAdvanceInterestEvent } from './UpdateAdvanceInterestEvent';
import { UpdateAutopaySettingsEvent } from './UpdateAutopaySettingsEvent';
import { UpdateBankruptcyEvent } from './UpdateBankruptcyEvent';
import { UpdateBillSettingsEvent } from './UpdateBillSettingsEvent';
import { UpdateDelinquentInterestRateEvent } from './UpdateDelinquentInterestRateEvent';
import { UpdateDocumentBorrowerAccessEvent } from './UpdateDocumentBorrowerAccess';
import { UpdateDocumentTitleEvent } from './UpdateDocumentTitleEvent';
import { UpdateEscrowCompanyEvent } from './UpdateEscrowCompanyEvent';
import { UpdateEscrowDueEvent } from './UpdateEscrowDueEvent';
import { UpdateEscrowPaymentEvent } from './UpdateEscrowPaymentEvent';
import { UpdateEscrowSettingEvent } from './UpdateEscrowSettingEvent';
import { UpdateFeesEvent } from './UpdateFeesEvent';
import { UpdateIdsAndRemittanceDataEvent } from './UpdateIdsAndRemittanceDataEvent';
import { UpdateLoanBoardedDatesEvent } from './UpdateLoanBoardedDatesEvent';
import { UpdateLoanEvent } from './UpdateLoanEvent';
import { UpdateMonthlyInterestRateEvent } from './UpdateMonthlyInterestRateEvent';
import { UpdateNoteflowDocumentIdEvent } from './UpdateNoteflowDocumentIdEvent';
import { UpdatePaymentEvent } from './UpdatePaymentEvent';
import { UpdateRemittanceSplitEvent } from './UpdateRemittanceSplitEvent';
import { UpdateSentEmailEvent } from './UpdateSentEmailEvent';
import { UpdateStopSettingsEvent } from './UpdateStopSettingsEvent';
import { UpdateTransferDataEvent } from './UpdateTransferDataEvent';
import { UpdateTransferEvent } from './UpdateTransferEvent';
import { UpsertReportableEvent } from './UpsertReportableEvent';
import { UsioMarkAsCancelledEvent } from './UsioMarkAsCancelledEvent';
import { UsioMarkAsFailedEvent } from './UsioMarkAsFailedEvent';
import { UsioMarkAsProcessedEvent } from './UsioMarkAsProcessedEvent';
import { UsioTransactionBatchedEvent } from './UsioTransactionBatchedEvent';
import { WaiveDelinquentInterestEvent } from './WaiveDelinquentInterestEvent';
import { ArchiveWorkoutPlanEvent } from './WorkoutPlans/ArchiveWorkoutPlanEvent';
import { CancelWorkoutPlanEvent } from './WorkoutPlans/CancelWorkoutPlanEvent';
import { CreateWorkoutPlanEvent } from './WorkoutPlans/CreateWorkoutPlanEvent';
import { CompleteFlexModWorkoutPlanEvent } from './WorkoutPlans/FlexMod/CompleteFlexModWorkoutPlanEvent';
import { CreateWorkoutPlanFlexModEvent } from './WorkoutPlans/FlexMod/CreateWorkoutPlanFlexModEvent';
import { FlexModCancellationEvent } from './WorkoutPlans/FlexMod/FlexModCancellationEvent';
import { CancelForbearanceWorkoutPlanEvent } from './WorkoutPlans/Forbearance/CancelForbearanceWorkoutPlanEvent';
import { CompleteForbearanceWorkoutPlanEvent } from './WorkoutPlans/Forbearance/CompleteForbearanceWorkoutPlanEvent';
import { CreateWorkoutPlanForbearanceEvent } from './WorkoutPlans/Forbearance/CreateWorkoutPlanForbearanceEvent';
import { ExtendForbearanceWorkoutPlanEvent } from './WorkoutPlans/Forbearance/ExtendForbearanceWorkoutPlanEvent';
import { ScheduleForbearanceWorkoutPlanCancellationEvent } from './WorkoutPlans/Forbearance/ScheduleForbearanceWorkoutPlanCancellationEvent';
import { CancelRepaymentWorkoutPlanEvent } from './WorkoutPlans/RepaymentPlan/CancelRepaymentWorkoutPlanEvent';
import { CompleteRepaymentWorkoutPlanEvent } from './WorkoutPlans/RepaymentPlan/CompleteRepaymentWorkoutPlanEvent';
import { CreateRepaymentWorkoutPlanEvent } from './WorkoutPlans/RepaymentPlan/CreateRepaymentWorkoutPlanEvent';

export const LoanEvent = z.discriminatedUnion('type', [
  FlagAccountEvent,
  ForceUpdateEvent,
  CreationEvent,
  TransferAccountEvent,
  CreatePaymentEvent,
  CreateDepositEvent,
  CreateBalanceReallocationEvent,
  CreateFeePaymentEvent,
  CreateMultipleFeesPaymentEvent,
  CreateAdvancePaymentEvent,
  CreatePrincipalPrepaymentEvent,
  CreateTransferEvent,
  CreateClawBackTransferEvent,
  UpdatePaymentEvent,
  UpdateTransferEvent,
  ReversePaymentEvent,
  ReversePayoffEvent,
  GenerateManualStatementEvent,
  EditManualStatementEvent,
  GenerateNextStatementEvent,
  NextAmortizationMonthEvent,
  CreateDisbursementEvent,
  CreateForwardPaymentDisbursementEvent,
  CreatePaymentAfterPayoffDisbursementEvent,
  ReverseDisbursementEvent,
  SendGoodbyeEmailEvent,
  SendMortgageeLetterEvent,
  SendWelcomeEmailEvent,
  MoveToTransferEvent,
  SendPaymentReminderEmailEvent,
  SendLatePaymentEmailEvent,
  SendGracePastDueEmailEvent,
  GracePastDueAutomationEvent,
  SendLenderEmailEvent,
  AddAdditionalBorrowerEvent,
  RemoveAdditionalBorrowerEvent,
  EditBorrowerEvent,
  ChangePrimaryBorrowerEvent,
  SaveStatementPdfEvent,
  UpdateDocumentTitleEvent,
  UpdateDocumentBorrowerAccessEvent,
  DeleteDocumentEvent,
  SendEscrowCompanyEmailsEvent,
  SendFinalPaymentEmailEvent,
  RegenerateStatementEvent,
  RegenerateStatementPdfEvent,
  RegenerateTransferDocumentsEvent,
  AddAccountCommentEvent, // deprecated
  CreateFeeEvent,
  CancelFeeEvent,
  UpdateFeesEvent,
  CreateDrawEvent,
  UpdateAutopaySettingsEvent,
  ReverseDrawEvent,
  EditEscrowFieldsEvent,
  ModifyMaturityDateEvent,
  ModifyPropertyAddressEvent,
  CreatePropertyAddressEvent,
  DeletePropertyAddressEvent,
  AddAuditLogItemEvent,
  CreateRequestedPayoffEvent,
  CreatePayoffEvent,
  RecordPayoffEvent,
  UpdateAdvanceInterestEvent,
  CreateAdvanceEvent,
  UpdateMonthlyInterestRateEvent,
  GenerateGoodbyeLetterPdfEvent,
  UpdateEscrowSettingEvent,
  UpdateEscrowCompanyEvent,
  UpdateEscrowDueEvent,
  CreateEscrowSettingEvent,
  UsioMarkAsCancelledEvent,
  UsioMarkAsFailedEvent,
  UsioMarkAsProcessedEvent,
  UsioTransactionBatchedEvent,
  UpdateIdsAndRemittanceDataEvent,
  UpdateLoanEvent,
  UpdateLoanBoardedDatesEvent,
  ConstructionToPermanentEvent,
  CreateWorkoutPlanEvent,
  CancelWorkoutPlanEvent,
  ArchiveWorkoutPlanEvent,
  CreateWorkoutPlanForbearanceEvent,
  CreateWorkoutPlanFlexModEvent,
  ExtendForbearanceWorkoutPlanEvent,
  ScheduleForbearanceWorkoutPlanCancellationEvent,
  CancelForbearanceWorkoutPlanEvent,
  CompleteForbearanceWorkoutPlanEvent,
  FlexModCancellationEvent,
  CompleteFlexModWorkoutPlanEvent,
  CreateRepaymentWorkoutPlanEvent,
  CancelRepaymentWorkoutPlanEvent,
  CompleteRepaymentWorkoutPlanEvent,
  UpdateDelinquentInterestRateEvent,
  UpdateRemittanceSplitEvent,
  WaiveDelinquentInterestEvent,
  DeferDelinquentInterestEvent,
  UpdateBillSettingsEvent,
  MailMonthlyStatementTaskEvent,
  UpdateTransferDataEvent,
  AddAppraisalEvent,
  AddAppraisalOrderEvent,
  AddInspectionEvent,
  AddInspectionOrderEvent,
  UpdateNoteflowDocumentIdEvent,
  CreatePrincipalModificationEvent,
  ReversePrincipalModificationEvent,
  RecordWriteoffEvent,
  RepayMarkAsProcessedEvent,
  RepayMarkAsCancelledEvent,
  RepayMarkAsFailedEvent,
  CreateVerificationOfMortgageEvent,
  CreateLoanExtensionAgreementEvent,
  PrincipalLateAutomationEvent,
  CreateLoanExtensionFeesDocumentEvent,
  UpdateBankruptcyEvent,
  LogCallEvent,
  AddLoanNoteEvent,
  ReallocatePaymentsEvent,
  UpsertReportableEvent,
  DeleteReportableEventEvent,
  UpdateStopSettingsEvent,

  // LOAN STATUS
  SetLoanStatusEvent,
  RecordReoEvent,
  RecordLiquidationEvent,
  SetLoanStatusForeclosureEvent,

  // nested
  SendEmailEvent,
  UpdateSentEmailEvent,
  SendExternalEmailEvent,
  SaveDocumentPdfEvent,
  UpdateEscrowPaymentEvent,
]);
export type LoanEvent = z.infer<typeof LoanEvent>;

export const LoanEventWithAuditLog = z.discriminatedUnion('type', [
  FlagAccountEvent,
  ReverseDisbursementEvent,
  CreationEvent,
  TransferAccountEvent,
  CreatePaymentEvent,
  ReversePaymentEvent,
  ReversePayoffEvent,
  GenerateManualStatementEvent,
  EditManualStatementEvent,
  GenerateNextStatementEvent,
  SaveDocumentPdfEvent,
  DeleteDocumentEvent,
  UpdateDocumentTitleEvent,
  UpdateDocumentBorrowerAccessEvent,
  CreateDisbursementEvent,
  CreateForwardPaymentDisbursementEvent,
  CreatePaymentAfterPayoffDisbursementEvent,
  MoveToTransferEvent,
  AddAdditionalBorrowerEvent,
  RemoveAdditionalBorrowerEvent,
  ChangePrimaryBorrowerEvent,
  AddAccountCommentEvent, // deprecated
  RegenerateStatementEvent,
  RegenerateStatementPdfEvent,
  CreateFeeEvent,
  CancelFeeEvent,
  UpdateFeesEvent,
  EditBorrowerEvent,
  CreateDrawEvent,
  ReverseDrawEvent,
  UpdateAutopaySettingsEvent,
  EditEscrowFieldsEvent,
  ModifyMaturityDateEvent,
  ModifyPropertyAddressEvent,
  CreatePropertyAddressEvent,
  DeletePropertyAddressEvent,
  AddAuditLogItemEvent,
  CreateRequestedPayoffEvent,
  CreatePayoffEvent,
  RecordPayoffEvent,
  CreateAdvanceEvent,
  UpdateMonthlyInterestRateEvent,
  UpdateEscrowSettingEvent,
  UpdateEscrowCompanyEvent,
  UpdateEscrowDueEvent,
  CreateEscrowSettingEvent,
  CreateFeePaymentEvent,
  CreateMultipleFeesPaymentEvent,
  CreateAdvancePaymentEvent,
  UpdateEscrowPaymentEvent,
  UpdateIdsAndRemittanceDataEvent,
  UpdateLoanEvent,
  UpdateLoanBoardedDatesEvent,
  ConstructionToPermanentEvent,
  CreateWorkoutPlanEvent,
  CancelWorkoutPlanEvent,
  ArchiveWorkoutPlanEvent,
  CreateWorkoutPlanForbearanceEvent,
  ExtendForbearanceWorkoutPlanEvent,
  CompleteForbearanceWorkoutPlanEvent,
  ScheduleForbearanceWorkoutPlanCancellationEvent,
  CancelForbearanceWorkoutPlanEvent,
  CreateWorkoutPlanFlexModEvent,
  FlexModCancellationEvent,
  CompleteFlexModWorkoutPlanEvent,
  CreateRepaymentWorkoutPlanEvent,
  CancelRepaymentWorkoutPlanEvent,
  CompleteRepaymentWorkoutPlanEvent,
  UpdateRemittanceSplitEvent,
  UpdateDelinquentInterestRateEvent,
  WaiveDelinquentInterestEvent,
  DeferDelinquentInterestEvent,
  UpdateBillSettingsEvent,
  UpdateTransferDataEvent,
  CreateDepositEvent,
  CreateBalanceReallocationEvent,
  AddAppraisalEvent,
  AddAppraisalOrderEvent,
  AddInspectionEvent,
  AddInspectionOrderEvent,
  CreatePrincipalModificationEvent,
  ReversePrincipalModificationEvent,
  RecordWriteoffEvent,
  CreateVerificationOfMortgageEvent,
  CreateLoanExtensionAgreementEvent,
  CreateLoanExtensionFeesDocumentEvent,
  ReallocatePaymentsEvent,
  UpdateStopSettingsEvent,
  UpsertReportableEvent,
  DeleteReportableEventEvent,
  AddLoanNoteEvent,
  LogCallEvent,

  // LOAN STATUS
  SetLoanStatusEvent,
  UpdateBankruptcyEvent,
  RecordReoEvent,
  RecordLiquidationEvent,
  SetLoanStatusForeclosureEvent,
]);
export type LoanEventWithAuditLog = z.infer<typeof LoanEventWithAuditLog>;
